import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import BillTable from "./components/BillingTable";  


const BillingIndex = () => {
  const [searchTerm, setSearchTerm] = useState("");
  

  return (
    <div className="p-4">
      {/* 🔹 Top Bar */}
      <div className="mb-4 flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
        <h1 className="text-xl font-bold text-gray-800 dark:text-white">
          Billing Management
        </h1>

        <div className="flex flex-wrap gap-3">
          {/* Search */}
          <div className="relative">
            <input
              type="text"
              placeholder="Search bills..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="rounded border px-3 py-2 pr-10 text-sm outline-none dark:bg-navy-700 dark:text-white"
            />
            <FaSearch className="absolute right-3 top-2.5 text-gray-500" />
          </div>

          
        </div>
      </div>

      {/* 🔹 Bill Table */}
      <BillTable search={searchTerm} />

      
    </div>
  );
};

export default BillingIndex;
